import React, { Fragment } from 'react'

const Input = ({item, register, errors, onChange}) => {
    return (
        <Fragment>
            <div className="flex flex-col col-span-6 max-[573px]:col-span-12 gap-2">
                <label className="text-[12px] font-medium">{item?.label}</label>
                <div className='flex flex-col gap-1'>
                    <input
                    disabled={item?.disabled}
                    type={item?.type}
                    name={item.name}
                    {...register(item.name, {
                        onChange: onChange
                    })}
                    placeholder={item?.placeholder}
                    className="border h-[42px] border-gray-200 pl-4 rounded-lg text-[12px] font-medium pr-3"
                    bordered={true}
                    />
                    <div className='text-[red] italic text-[11px]'>{errors[item?.name]?.message}</div>
                </div>
            </div>
        </Fragment>
    )
}

export default Input